module.exports = __webpack_public_path__ + "static/media/me.897083e4.jpg";